module.exports = __webpack_public_path__ + "static/img/bcg1.92522f13.webp";